/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const IconCheckmark = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M13.62 3.47a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0L2.378 8.35a.75.75 0 0 1 1.06-1.061L6.09 9.939l6.47-6.47a.75.75 0 0 1 1.06 0'
      clipRule='evenodd'
    />
  </svg>
)
